var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchbar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4408 15.7799C13.0042 16.9555 11.1679 17.6608 9.16683 17.6608C4.56446 17.6608 0.833496 13.9298 0.833496 9.32747C0.833496 4.7251 4.56446 0.994141 9.16683 0.994141C13.7692 0.994141 17.5002 4.7251 17.5002 9.32747C17.5002 11.3285 16.7948 13.1649 15.6193 14.6014L18.9227 17.9049C19.2481 18.2303 19.2481 18.758 18.9227 19.0834C18.5973 19.4088 18.0696 19.4088 17.7442 19.0834L14.4408 15.7799ZM15.8335 9.32747C15.8335 13.0094 12.8487 15.9941 9.16683 15.9941C5.48493 15.9941 2.50016 13.0094 2.50016 9.32747C2.50016 5.64558 5.48493 2.66081 9.16683 2.66081C12.8487 2.66081 15.8335 5.64558 15.8335 9.32747Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbar);
export default __webpack_public_path__ + "static/media/searchbar.93b29e0d5d218d89bd29910497f14c67.svg";
export { ForwardRef as ReactComponent };